import type { Plan, PlanExternal } from '@helloextend/extend-api-client'

export function getIsAdhPlan(plan: PlanExternal): boolean {
  return plan.contract.coverage_includes.includes('adh')
}

export function isJewelryPlan(plan: Plan): boolean {
  return plan.contract.category === 'jewelry'
}
